import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, LoadingState, EmptyState } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/format";
import { Bell, CheckCheck, FolderOpen, UserRound, UserCog } from "lucide-react";

const Notifications = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], non_lette: 0 });
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get("/notifications").then(({ data }) => setData(data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const openN = async (n) => { await api.post(`/notifications/${n.id}/read`); if (n.case_id) navigate(`/app/pratiche/${n.case_id}`); else load(); };
  return (
    <div>
      <PageHeader icon={Bell} title="Notifiche" description={`${data.non_lette} non lette`}
        actions={data.non_lette > 0 && <Button variant="outline" onClick={readAll}><CheckCheck className="h-4 w-4 mr-2" /> Segna tutte lette</Button>} />
      {loading ? <LoadingState /> : data.items.length === 0 ? <EmptyState title="Nessuna notifica" /> : (
        <Card className="divide-y">
          {data.items.map((n) => (
            <button key={n.id} onClick={() => openN(n)} className={`w-full text-left p-4 hover:bg-muted transition-colors ${!n.letta ? "bg-[color:var(--brand-blue-100)]/40" : ""}`} data-testid="notification-item">
              <div className="flex items-center justify-between gap-2"><span className="font-medium">{n.titolo}</span><span className="text-xs text-muted-foreground shrink-0">{fmtDateTime(n.created_at)}</span></div>
              <div className="text-sm text-muted-foreground mt-0.5">{n.corpo}</div>
              {(n.numero_pratica || n.persona_nome || n.gestore_nome) && (
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2">
                  {n.numero_pratica && (
                    <span className="inline-flex items-center gap-1 text-[11px] font-medium text-[color:var(--brand-blue-700)]" data-testid="notification-numero-pratica">
                      <FolderOpen className="h-3.5 w-3.5" /> {n.numero_pratica}
                    </span>
                  )}
                  {n.persona_nome && (
                    <span className="inline-flex items-center gap-1 text-[11px] text-slate-600" data-testid="notification-persona">
                      <UserRound className="h-3.5 w-3.5" /> {n.persona_nome}
                    </span>
                  )}
                  {n.gestore_nome && (
                    <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[color:var(--brand-green-700)]" data-testid="notification-gestore">
                      <UserCog className="h-3.5 w-3.5" /> Gestore: {n.gestore_nome}
                    </span>
                  )}
                </div>
              )}
            </button>
          ))}
        </Card>
      )}
    </div>
  );
};

export default Notifications;
